import Vue from "vue";
import axios from "axios";
import moment from "moment";

enum OperationTypes {
  Reserve = 1,
  Release = 2,
}

export default {
  name: "MeterReservation",
  components: {
    MetersDataGrid: require("./metersDataGrid/metersDataGrid.vue").default,
    DataGridComp: require("@/customcontrols/datagrid.vue").default,
    SearchFields: require("./metersDataGrid/searchFields.vue").default,
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
  },
  props: {
    dataObj: {
      type: Object,
      required: false,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      toBeDeleted: null,
      showUndoReleaseMeterConfirmationDialog: false,
      showDeleteMeterConfirmationDialog: false,
      showReleaseMeterConfirmationDialog: false,
      cols: [],
      OperationTypes,
      assignTo: null,
      meterType: null,
      meterTypes: [],
      meterRef: null,
      employees: [],
      operationType: null,
      employee: {},
      showDialog: false,
      userProf: null,
      selectedMeters: [],
      metersToBeImported: [],
      search: {
        typeId: "",
        meterRef: "",
        employee: "",
        trimMeters: false,
      },
      metersTrimmed: [],
      metersToBeReleasedTrimmed: [],
      searchFields: {
        meterType: true,
        meterRef: true,
        employee: true,
        showOnlyOwnMeters: this.dataObj.operationType == OperationTypes.Release,
      },
      activeTab: "tab-available-meters",
    };
  },
  computed: {},
  watch: {
    employee: function (val) {
      if (!val) return;

      this.dataObj.employeeId = val.id;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.fillApplicationsColumns();
      this.getLookups();

      let temp = this.$store.getters.getUserProfile;
      if (temp) this.userProf = temp;

      this.dataObj.meters.forEach((m) => {
        m.isSelected = false;
        m.toImport = false;

        this.metersTrimmed.push(m);
      });

      this.searchFunction();
    },
    fillApplicationsColumns() {
      this.cols = [];

      this.cols.push({
        dataField: "isSelected",
        name: "selected",
        caption: this.$t("sendEmail.selected"),
      });
      this.cols.push({
        dataField: "typeId",
        name: "type",
        caption: this.$t("sendEmail.type"),
      });
      this.cols.push({
        dataField: "reference",
        name: "reference",
        caption: this.$t("customReadings.Reference"),
      });
      this.cols.push({
        dataField: "serialNo",
        name: "serialNo",
        caption: this.$t("disconnections.MeterSerialNo"),
        dataType: "date",
      });
      this.cols.push({
        dataField: "size",
        name: "size",
        caption: this.$t("activities.size"),
        dataType: "string",
        evaluateAsTime: true,
      });
      this.cols.push({
        dataField: "employeeName",
        name: "employeeName",
        caption: this.$t("jobcardDetail.employee"),
      });
      this.cols.push({
        dataField: "stampUser",
        name: "stampUser",
        caption: this.$t("enquiries.stampUser"),
      });
      this.cols.push({
        dataField: "stampDateTimeDisplay",
        name: "stampDateTime",
        caption: this.$t("enquiriesCustomerDetails.stampDateTime"),
      });
    },
    getLookups() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      axios
        .post("/ReserveMetersActivity/GetLookups")
        .then((resp) => {
          if (resp.status == 200) {
            this.meterTypes = resp.data.types;

            this.employees = resp.data.employees;
            if (this.employees && this.employees.length > 0) {
              let temp = this.employees.filter(
                (e) => e.id == this.userProf.employeeId
              );

              if (temp && temp.length) this.employee = temp[0];
              else this.employee = this.employees[0];
            }
          }
        })
        .catch((err) => console.log("err", err))
        .finally(() => {
          loader.hide();
        });
    },
    onCellClick(item) {
      const index = this.dataObj.meters.findIndex((m) => m.id == item.data.id);
      if (index !== -1) {
        this.dataObj.meters[index].isSelected =
          !this.dataObj.meters[index].isSelected;
      }
    },
    onCellClickReleasedMeters(item) {
      const index = this.dataObj.metersToBeReleased.findIndex(
        (m) => m.id == item.data.id
      );
      if (index !== -1) {
        this.dataObj.metersToBeReleased[index].isSelected =
          !this.dataObj.metersToBeReleased[index].isSelected;
      }
    },
    searchFunction() {
      const filter = (meters) => {
        return meters.filter((m) => {
          return (
            (this.search.typeId ? m.typeId == this.search.typeId : true) &&
            (this.search.meterRef
              ? m.reference
                  .toLowerCase()
                  .includes(this.search.meterRef.toLowerCase())
              : true) &&
            (this.search.employee
              ? m.employeeName
                  .toLowerCase()
                  .includes(this.search.employee.toLowerCase())
              : true) &&
            (this.search.trimMeters
              ? m.employeeName == this.userProf.name
              : true)
          );
        });
      };

      this.metersTrimmed = filter(this.dataObj.meters);
      this.metersToBeReleasedTrimmed = filter(this.dataObj.metersToBeReleased);
    },
    reserveReleaseMeter(type = OperationTypes.Reserve, undoAction = false) {
      if (type == OperationTypes.Reserve) {
        this.dataObj.meters.forEach((meter) => {
          if (meter.isSelected) {
            meter.employeeId = this.employee.id;
            meter.employeeName = this.employee.displayString;
          }
        });
      } else {
        const released = [];
        const remaining = [];
        const pushIsSelected = (m) =>
          m.isSelected === false ? m : { ...m, isSelected: false };

        if (undoAction) {
          for (const m of this.dataObj.metersToBeReleased) {
            if (m.isSelected) remaining.push(pushIsSelected(m));
            else released.push(m);
          }

          this.dataObj.meters.push(...remaining);
        } else {
          for (const m of this.dataObj.meters) {
            if (m.isSelected) released.push(pushIsSelected(m));
            else remaining.push(m);
          }

          this.dataObj.meters = remaining;
        }

        this.dataObj.metersToBeReleased = released;
        this.searchFunction();

        this.showReleaseMeterConfirmationDialog = false;
      }

      this.$root.$emit("refresh_data_grid:meters-grid");
      this.$root.$emit("refresh_data_grid:released-meters-grid");
    },
    openMeterDialog(action = true) {
      if (action) {
        this.metersToBeImported = [];
      } else {
        this.metersToBeImported.forEach((meter) => {
          if (!this.dataObj.meters.some((m) => m.id === meter.id)) {
            this.dataObj.meters.push({
              id: meter.id,
              isSelected: false,
              employeeId: this.employee.id,
              typeId: meter.typeId,
              reference: meter.displayString,
              serialNo: meter.displayString,
              size: meter.size,
              employeeName: this.employee.displayString,
              stampUser: this.userProf.name,
              stampDateTime: moment().format(),
              stampDateTimeDisplay: moment().format("DD/MM/YYYY HH:mm"),
            });
          }
        });

        this.metersToBeImported = [];
        this.searchFunction();

        this.$root.$emit("refresh_data_grid:meters-grid");
      }

      this.showDialog = action;
    },
    onMetersSelected(meter) {
      this.metersToBeImported.length = 0;
      this.metersToBeImported = [...meter];
    },
    openDeleteMeterConfirmation(item) {
      if (this.dataObj.operationType == OperationTypes.Release) return;

      this.toBeDeleted = item.data;
      this.showDeleteMeterConfirmationDialog = true;
    },
    closeDeleteMeterConfirmation() {
      this.toBeDeleted = null;
      this.showDeleteMeterConfirmationDialog = false;
    },
    deleteMeter() {
      this.dataObj.meters = this.dataObj.meters.filter(
        (m) => m.serialNo != this.toBeDeleted.serialNo
      );

      this.searchFunction();
    },
    searchFieldsChanged(search) {
      this.search.typeId = search.typeId;
      this.search.meterRef = search.meterRef;
      this.search.employee = search.employee;
      this.search.trimMeters = search.trimMeters;

      this.searchFunction();
    },
    validateAppData() {
      if (
        this.dataObj.operationType == OperationTypes.Release &&
        this.dataObj.metersToBeReleased.length == 0
      ) {
        this.$oldAlertMsg(this.$t("ReserveMeter.NoMetersToRelease"), 2);
        return false;
      }

      if (
        this.dataObj.operationType == OperationTypes.Reserve &&
        this.dataObj.meters.length == 0
      ) {
        this.$oldAlertMsg(this.$t("ReserveMeter.NoMetersToReserve"), 2);
        return false;
      }

      return true;
    },
  },
};
